const newsConstantsAr = {
  newsTitle: 'الاخبار',
  arabicTitle: 'العنوان بالعربية',
  englishTitle: 'العنوان بالإنجليزية',
  publishDate: 'تاريخ النشر',
  blogStatus: 'الحالة',
  newsStatusPublished: 'منشور',
  newsStatusUnpublished: 'غير منشور',
  totalNews: 'خبر',
  deleteNewsTitle: 'حذف الخبر',
  deleteNewsContent: 'هل أنت متأكد أنك تريد حذف هذه الخبر من لوحة الإدارة ؟',
  snackbarDeletedMsg: 'تم الحذف بنجاح',
};
export default newsConstantsAr;
